import { useDispatch, useSelector } from 'react-redux';
import {
  loginUser,
  userLoadingSelector
} from '../redux/features/user/usersSlice';
import { useRedirectLoggedUserToDashboard } from './useRedirectLoginUserToDashboard';

export const useLoginUser = () => {
  useRedirectLoggedUserToDashboard();
  const dispatch = useDispatch();
  const isLoading = useSelector(userLoadingSelector);

  const loginUserAction = async ({ email, password, recaptchaToken }) => {
    try {
      dispatch(loginUser({ email, password, recaptchaToken }));
      return { success: true };
    } catch (error) {
      return { success: false, error };
    }
  };

  return { loginUser: loginUserAction, isLoading };
};
